module.exports = __webpack_public_path__ + "static/media/conexion.b94d03a9.svg";